"use client";
import { FC, useState } from "react";
import { getDataLinkAttributes } from "@/helpers";
import { ComponentWithAnalyticsGlobalField } from "@solarwinds-webbiz/types";
import { InteractiveTableDialog } from "./InteractiveTableDialog";
import { InfoCircleIcon } from "@/icons";

type CellWithDialogProps = {
  title: string;
  dialogContent?: string;
  analytics?: ComponentWithAnalyticsGlobalField;
};

const CellWithDialog: FC<CellWithDialogProps> = ({
  title,
  dialogContent,
  analytics,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasDialog = !!dialogContent;

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  const btnClass = "flex items-center justify-center text-subhead-xs font-bold";

  return (
    <>
      {hasDialog ? (
        <button
          onClick={openDialog}
          className={btnClass}
          {...getDataLinkAttributes(analytics)}
        >
          <span>{title}&nbsp;</span>
          <InfoCircleIcon />
        </button>
      ) : (
        <p className={btnClass}>{title}</p>
      )}

      {hasDialog && (
        <InteractiveTableDialog
          isOpen={isOpen}
          closeDialog={closeDialog}
          headline={title}
          content={dialogContent}
        />
      )}
    </>
  );
};

export default CellWithDialog;
